(() => {
  'use strict';
  let busy = false;
  let cartOpener = null;
  const route = endpoint => `${window.Shopify?.routes?.root || '/'}${endpoint}`;
  const dialog = () => document.getElementById('cc-cart-dialog');
  const strings = () => window.ccStrings || {};
  const sectionIds = () => [...new Set([...document.querySelectorAll('[data-cc-cart-section]')].map(el => el.dataset.ccCartSection))].slice(0, 5);

  function lockScroll() { document.documentElement.classList.toggle('cc-modal-open', !!document.querySelector('dialog[open]')); }
  function closeCart() {
    dialog()?.close();
    lockScroll();
    if (cartOpener?.isConnected) cartOpener.focus({ preventScroll: true });
  }
  function openCart(trigger = document.activeElement) {
    const element = dialog();
    if (!element) { location.assign(route('cart')); return; }
    if (trigger && !element.contains(trigger)) cartOpener = trigger;
    if (!element.open) element.showModal();
    element.querySelector('[data-cc-cart-close]')?.focus({ preventScroll: true });
    lockScroll();
  }
  function announce(message, error = false) {
    let region = document.getElementById('cc-cart-status');
    if (!region) {
      region = document.createElement('div'); region.id = 'cc-cart-status'; region.className = 'visually-hidden';
      region.setAttribute('role', 'status'); region.setAttribute('aria-live', 'polite'); document.body.append(region);
    }
    region.textContent = message;
    if (error) {
      document.querySelectorAll('[data-cc-cart-error]').forEach(el => { el.textContent = message; el.hidden = false; });
    }
  }
  function clearErrors(form) {
    document.querySelectorAll('[data-cc-cart-error]').forEach(el => { el.textContent = ''; el.hidden = true; });
    const productError = form?.querySelector('[data-cc-product-error]');
    if (productError) { productError.textContent = ''; productError.hidden = true; }
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-cc-cart-section]').forEach(el => {
      el.setAttribute('aria-busy', String(value));
      el.querySelectorAll('[data-cc-quantity], [data-cc-line-quantity], [data-cc-checkout]').forEach(control => {
        if (value) { control.dataset.ccWasDisabled = control.disabled ? 'true' : 'false'; control.disabled = true; }
        else if ('ccWasDisabled' in control.dataset) { control.disabled = control.dataset.ccWasDisabled === 'true'; delete control.dataset.ccWasDisabled; }
      });
    });
  }
  async function jsonFetch(url, options) {
    let response;
    try { response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options?.headers } }); }
    catch { throw new Error(strings().cartUnconfirmed || 'We could not confirm that update. Check your cart before trying again.'); }
    let data;
    try { data = await response.json(); }
    catch { throw new Error(strings().cartUnconfirmed || 'We could not confirm that update. Check your cart before trying again.'); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : data.message || strings().cartError || 'Your cart could not be updated. Please try again.');
    return data;
  }
  function focusState() {
    const active = document.activeElement;
    const line = active?.closest('[data-cart-line]');
    if (!line) return null;
    return { section: active.closest('[data-cc-cart-section]')?.dataset.ccCartSection, key: line.dataset.key, index: [...line.parentElement.querySelectorAll('[data-cart-line]')].indexOf(line), quantity: active.dataset.ccQuantity, input: active.hasAttribute('data-cc-line-quantity'), remove: active.hasAttribute('data-cc-cart-remove') };
  }
  function restoreFocus(saved) {
    if (!saved) return;
    const section = [...document.querySelectorAll('[data-cc-cart-section]')].find(el => el.dataset.ccCartSection === saved.section);
    const lines = [...section?.querySelectorAll('[data-cart-line]') || []];
    const line = lines.find(el => el.dataset.key === saved.key) || lines[Math.min(saved.index, lines.length - 1)];
    const selector = saved.input ? '[data-cc-line-quantity]' : saved.remove ? '[data-cc-cart-remove]' : `[data-cc-quantity="${saved.quantity}"]`;
    let target = line?.querySelector(selector) || section?.querySelector('[data-cc-checkout], [data-cc-cart-close], a');
    if (target?.disabled) target = line?.querySelector('[data-cc-line-quantity]') || target;
    target?.focus({ preventScroll: true });
  }
  function renderSections(sections) {
    const parser = new DOMParser();
    for (const [id, html] of Object.entries(sections || {})) {
      if (typeof html !== 'string') continue;
      const current = document.getElementById(`shopify-section-${id}`);
      const parsed = parser.parseFromString(html, 'text/html');
      const next = parsed.getElementById(`shopify-section-${id}`);
      if (!current || !next) continue;
      const currentDialog = current.querySelector('#cc-cart-dialog');
      const nextDialog = next.querySelector('#cc-cart-dialog');
      if (currentDialog && nextDialog) {
        currentDialog.replaceChildren(...nextDialog.childNodes);
        currentDialog.dataset.ccCartCount = nextDialog.dataset.ccCartCount;
      } else current.replaceChildren(...next.childNodes);
    }
    document.dispatchEvent(new CustomEvent('cc:content-updated'));
  }
  async function refreshCart(sections) {
    const ids = sectionIds();
    let rendered = sections;
    if (ids.length && ids.some(id => typeof rendered?.[id] !== 'string')) {
      rendered = await jsonFetch(`${route('cart')}?sections=${encodeURIComponent(ids.join(','))}`);
    }
    const cart = await jsonFetch(route('cart.js'));
    renderSections(rendered);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count); el.hidden = cart.item_count === 0; el.classList.toggle('is-wide', cart.item_count > 99); el.classList.toggle('cart-count--wide', cart.item_count > 99); });
    document.querySelectorAll('[data-cart-link]').forEach(el => el.setAttribute('data-count', String(cart.item_count)));
    document.dispatchEvent(new CustomEvent('cc:cart-updated', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }
  async function changeLine(key, quantity) {
    if (busy || !key || !Number.isInteger(quantity) || quantity < 0) return;
    const focus = focusState(); clearErrors(); setBusy(true);
    try {
      const cart = await jsonFetch(route('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: sectionIds(), sections_url: location.pathname }) });
      await refreshCart(cart.sections);
      announce(strings().cartUpdated || 'Your cart has been updated.');
    } catch (error) {
      try { await refreshCart(); } catch { }
      announce(error.message, true);
    } finally { setBusy(false); restoreFocus(focus); }
  }
  async function addProduct(form, submitter) {
    if (busy || !form.reportValidity()) return;
    clearErrors(form);
    const controls = [...form.elements].filter(el => el.type === 'submit');
    const previous = controls.map(el => el.disabled);
    const body = new FormData(form);
    if (!body.get('id')) return;
    body.set('sections', sectionIds().join(',')); body.set('sections_url', location.pathname);
    setBusy(true); controls.forEach(el => el.disabled = true); form.setAttribute('aria-busy', 'true');
    let added = false;
    try {
      const result = await jsonFetch(route('cart/add.js'), { method: 'POST', body });
      added = true;
      await refreshCart(result.sections);
      openCart(submitter || form.querySelector('[type="submit"]'));
      announce(strings().cartAdded || 'Added to your cart.');
      document.dispatchEvent(new CustomEvent('cc:cart-added', { detail: { items: result.items || [result] } }));
    } catch (error) {
      try { await refreshCart(); } catch { }
      const message = added ? (strings().cartAddedRefreshError || 'Your item was added. Open your cart to review it before adding again.') : error.message;
      const output = form.querySelector('[data-cc-product-error]');
      if (output) { output.textContent = message; output.hidden = false; }
      announce(message, true);
      if (added) openCart(submitter);
    } finally {
      setBusy(false); form.removeAttribute('aria-busy'); controls.forEach((el, index) => el.disabled = previous[index] || (el.matches('[data-cc-atc]') && el.dataset.ccAvailable !== 'true'));
    }
  }
  function selectView(section, view) {
    section?.querySelector('.shop-product-grid')?.classList.toggle('shop-product-grid--list', view === 'list');
    section?.querySelectorAll('[data-cc-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ccView === view)));
  }
  function initialize(root = document) {
    let view = 'grid';
    try { view = sessionStorage.getItem('cc-collection-view') || 'grid'; } catch { }
    root.querySelectorAll('[data-cc-collection]').forEach(section => selectView(section, view));
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cc-cart-open]');
    if (opener) { event.preventDefault(); openCart(opener); return; }
    if (event.target.closest('[data-cc-cart-close]')) { closeCart(); return; }
    const quantity = event.target.closest('button[data-cc-quantity]');
    if (quantity) {
      const line = quantity.closest('[data-cart-line]'); const input = line.querySelector('[data-cc-line-quantity]');
      const next = Number(input.value) + Number(quantity.dataset.ccQuantity);
      if (next >= Number(input.min || 1) && (!input.max || next <= Number(input.max))) changeLine(line.dataset.key, next);
      return;
    }
    const remove = event.target.closest('[data-cc-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.closest('[data-cart-line]').dataset.key, 0); return; }
    const filterOpen = event.target.closest('[data-cc-filters-open]');
    if (filterOpen) { document.getElementById(filterOpen.getAttribute('aria-controls'))?.showModal(); lockScroll(); return; }
    const filterClose = event.target.closest('[data-cc-filters-close]');
    if (filterClose) { filterClose.closest('dialog')?.close(); lockScroll(); return; }
    const view = event.target.closest('[data-cc-view]');
    if (view) { selectView(view.closest('[data-cc-collection]'), view.dataset.ccView); try { sessionStorage.setItem('cc-collection-view', view.dataset.ccView); } catch { } }
    if (event.target.matches('dialog[open]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) { event.target.close(); lockScroll(); }
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-cc-product-form]')) { event.preventDefault(); addProduct(event.target, event.submitter); }
    if (busy && event.target.closest('[data-cc-cart-section]')) event.preventDefault();
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cc-sort-form] select')) event.target.form.requestSubmit();
    if (event.target.matches('[data-cc-line-quantity]') && event.target.value.trim() === '') { event.target.value = event.target.defaultValue; return; }
    if (event.target.matches('[data-cc-line-quantity]') && event.target.reportValidity()) changeLine(event.target.closest('[data-cart-line]').dataset.key, Number(event.target.value));
  });
  document.addEventListener('close', lockScroll, true);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart().catch(() => {}); });
  initialize();
})();
